import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ILocation, SearchStateType } from "../../../Orchestrator/Types/Index";

export class SelectedStopsForOriginAndDestination extends BaseAction<
  Partial<SearchStateType>,
  Partial<ILocation>
> {
  override async run(): Promise<Partial<SearchStateType>> {
    let searchData: Partial<SearchStateType> = {};
    try {
      const { field, id, name, search, isShuttle,geoPosition,fmlmSearch } = this.params!;
      if (search) {
        const modifiedData = {
          ...search,
          [field!]: id,
          [`${field}Name`]: name,
          [`${field}Shuttle`]: isShuttle,
          [`${field}GeoPosition`]: geoPosition,
          [`${field}fmlmSearch`]: fmlmSearch,
        };
        updateRecoilState("searchStateAtom", modifiedData);
        searchData = modifiedData;
      }
      updateRecoilState("fmlmSubStationDropdownAtom", {});
    } catch (error) {
      console.error("Error in SelectOriginDestinationAction:", error);
    } finally {
      return searchData;
    }
  }
}

// Create a singleton instance
export const selectedStopsForOriginAndDestination = new SelectedStopsForOriginAndDestination();
